import {
  SeptimaSearch,
  createCvrSearchController,
} from "../../../../SeptimaSearchReact";
import { ISeptimaSearchResultItem } from "../../../../SeptimaSearchReact/interfaces/types";
import ValidationErrorMessage from "../../../../formcontrols/ValidationErrorMessage";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../../../../select/Select";
import { FormikProps } from "formik";
import CloseIcon from "../../../../icons/CloseIcon";
import { IProduktionsenhed } from "../../../../../interfaces/firma";
import {
  TicketHeading,
  TicketSub,
  TicketSubItem,
} from "../../../../ticket/Ticket";
import IsRequired from "../../../../formcontrols/common/IsRequired";
import { useLayoutEffect, useRef, useState } from "react";

const Produktionsenhed = ({
  formik,
  produktionsEnheder,
  searchResult,
  setProduktionsEnheder,
  setSearchResult,
}: {
  formik: FormikProps<any>;
  searchResult: ISeptimaSearchResultItem | undefined;
  setSearchResult: React.Dispatch<
    React.SetStateAction<ISeptimaSearchResultItem | undefined>
  >;
  produktionsEnheder: IProduktionsenhed[];
  setProduktionsEnheder: React.Dispatch<
    React.SetStateAction<IProduktionsenhed[]>
  >;
}) => {
  const { setFieldValue, setFieldTouched, errors, values, touched } = formik;
  const [captureFocusOnMount, setCaptureFocusOnMount] = useState(false);
  return (
    <>
      <div className="w-100">
        <label className="form-label">
          Find virksomhed <IsRequired />
        </label>
        {searchResult && searchResult?.data ? (
          <CurrentSearchResultButton
            onClick={() => {
              setCaptureFocusOnMount(true);
              setFieldValue("produktionsenhed", undefined, true);
              setSearchResult(undefined);
              setProduktionsEnheder([]);
            }}
            navn={searchResult.data.navn}
            captureFocusOnMount={captureFocusOnMount}
          />
        ) : (
          <SeptimaSearch
            name="searchResult"
            controller={createCvrSearchController()}
            onResult={(res) => {
              setCaptureFocusOnMount(true);
              setSearchResult(res);
              const unitData =
                res.data?.produktionsEnheder?.filter((e) => e.er_aktiv) ?? [];
              setProduktionsEnheder(unitData);
              const firstProduktionsEnhed =
                unitData.length > 0 ? unitData[0] : undefined;
              setFieldTouched("produktionsenhed", true);
              setFieldValue("produktionsenhed", firstProduktionsEnhed, true);
            }}
            captureFocusOnMount={captureFocusOnMount}
          />
        )}{" "}
        <ValidationErrorMessage
          touched={touched.produktionsenhed}
          errorMessage={(errors.produktionsenhed as any)?.navn}
        />
      </div>
      <div className="w-100">
        <label className="form-label">
          Vælg produktionsenhed <IsRequired />
        </label>
        <Select
          disabled={produktionsEnheder.length === 0}
          value={
            values.produktionsenhed
              ? values.produktionsenhed.pnummer.toString()
              : ""
          }
          onValueChange={(value) => {
            const produktionsEnhed = produktionsEnheder.find(
              (pe) => pe.pnummer.toString() === value,
            );
            if (produktionsEnhed) {
              setFieldValue("produktionsenhed", produktionsEnhed, true);
            }
          }}
        >
          <SelectTrigger
            aria-label="Produktionsenhed"
            placeholder="Vælg..."
            className={
              touched.produktionsenhed && (errors.produktionsenhed as any)?.navn
                ? "is-invalid"
                : ""
            }
          />
          <SelectContent scrollable>
            {produktionsEnheder &&
              produktionsEnheder.map((pe) => {
                return (
                  <SelectItem
                    value={pe.pnummer.toString()}
                    key={pe.pnummer.toString()}
                    className="py-2"
                    style={{ height: "unset" }}
                  >
                    <TicketHeading>
                      <h4 className="h5" style={{ marginBottom: "0.15rem" }}>
                        {pe.navn}
                      </h4>
                    </TicketHeading>

                    <TicketSub>
                      <TicketSubItem>{pe.adresse}</TicketSubItem>
                    </TicketSub>

                    {/* <div className="ms-2">
                      <div>{pe.navn}</div>
                      <div style={{ fontSize: 12 }}>{pe.branche}</div>
                      <div style={{ fontSize: 12 }}>{pe.adresse}</div>
                    </div> */}
                  </SelectItem>
                );
              })}
          </SelectContent>
        </Select>
        <ValidationErrorMessage
          touched={touched.produktionsenhed}
          errorMessage={(errors.produktionsenhed as any)?.navn}
        />
      </div>
    </>
  );
};

export default Produktionsenhed;

function CurrentSearchResultButton(props: {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  navn: string;
  captureFocusOnMount: boolean;
}) {
  const { onClick, navn, captureFocusOnMount } = props;
  const ref = useRef<HTMLButtonElement>(null);
  useLayoutEffect(() => {
    if (captureFocusOnMount) {
      ref.current?.focus();
    }
  }, [captureFocusOnMount]);
  return (
    <button
      ref={ref}
      name="searchResult"
      type="button"
      className="form-control d-flex align-items-center justify-content-between"
      onClick={onClick}
    >
      <span>{navn}</span>
      <CloseIcon />
    </button>
  );
}
